import React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

import st from './FrameAnalysisFrequencyModal.module.sass';
import FramesImg from './png/frames.png';
import SecondsImg from './png/seconds.png';

export const FrameAnalysisFrequencyModal = () => {
  const { t } = useTranslation();

  const renderSection = (title, description, segmentLabel, imgSrc, segmentClass) => (
    <div className={st.Section}>
      <div className={st.SectionHeader}>
        <span className={st.SectionTitle}>{title}</span>
        <span className={st.SectionDescription}>{description}</span>
      </div>
      <div className={st.FrameBlock}>
        <span className={st.FrameLabel}>{t('constants:кадры')}</span>
        <div className={st.FrameContent}>
          <img
            alt={title}
            className={st.FrameImage}
            src={imgSrc}
          />
          <div className={st.SegmentList}>
            <div className={st.SegmentItem}>
              <div className={segmentClass} />
              <span className={st.SegmentLabel}>{segmentLabel}</span>
            </div>
            <div className={st.SegmentItem}>
              <div className={segmentClass} />
              <span className={st.SegmentLabel}>{segmentLabel}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={st.ModalBody}>
      <div className={st.Header}>
        <div className={st.HeaderTitle}>
          <InfoCircleFilledIcon className={st.Icon} />
          <span>{t('videoAnalytics:modal.frame analysis frequency')}</span>
        </div>
        <div className={st.HeaderDescription}>
          <span>{t('videoAnalytics:modal.which frames selected')}</span>
        </div>
      </div>

      {renderSection(
        t('videoAnalytics:form.rate.period.seconds'),
        t('videoAnalytics:modal.first frame taken and next ones'),
        t('videoAnalytics:modal.n seconds'),
        SecondsImg,
        st.SegmentSeconds,
      )}
      {renderSection(
        t('videoAnalytics:form.rate.period.frames'),
        t('videoAnalytics:modal.first and every N+1 frame'),
        t('videoAnalytics:modal.n frames'),
        FramesImg,
        st.SegmentFrames,
      )}
    </div>
  );
};
